import { cssTransition, toast } from 'react-toastify';
import { NotifCard } from 'Elements';
import moment from 'moment-jalaali';
import styles from 'partials/notification/notif-card.module.scss';

export const NotifWrapper = ({ list }) => {
	// Return match story based on story date
	const getMatchStory = (date) => {
		if (
			moment.unix(date).format('jD') === moment().format('jD') &&
			moment.unix(date).format('jM') === moment().format('jM')
		) {
			return true;
		}
		return false;
	};

	const flip = cssTransition({
		enter: 'animate__flipIn',
		exit: 'animate__flipOut'
	});
	// const uniqueId = new Date();
	const defaultOption = {
		position: 'bottom-left',
		hideProgressBar: false,
		autoClose: 10000,
		// delay: 10000,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		transition: flip
	};
	return (
		<div className={styles.wrapper}>
			{list?.map((elem) => {
				if (getMatchStory(elem.start_date)) {
					toast(<NotifCard card={elem} />, {
						...defaultOption,
						toastId: 'toast' + elem.id
					});
				}
			})}
		</div>
	);
};
